document.addEventListener('DOMContentLoaded', function () {
  var confirmButton = document.querySelector('.age-gate__confirm');
  if (!confirmButton) return;

  confirmButton.addEventListener('click', function () {
    try {
      localStorage.setItem('bandit_age_verified', 'true');
    } catch (error) {}
    document.documentElement.classList.add('age-verified');
  });
});
